/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEventEnum } from './APIEventEnum';
import {
    APIEventEnumFromJSON,
    APIEventEnumFromJSONTyped,
    APIEventEnumToJSON,
} from './APIEventEnum';

/**
 * 
 * @export
 * @interface APIEmailResendRequest
 */
export interface APIEmailResendRequest {
    /**
     * 
     * @type {string}
     * @memberof APIEmailResendRequest
     */
    email: string;
    /**
     * 
     * @type {APIEventEnum}
     * @memberof APIEmailResendRequest
     */
    event: APIEventEnum;
}



/**
 * Check if a given object implements the APIEmailResendRequest interface.
 */
export function instanceOfAPIEmailResendRequest(value: object): value is APIEmailResendRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function APIEmailResendRequestFromJSON(json: any): APIEmailResendRequest {
    return APIEmailResendRequestFromJSONTyped(json, false);
}

export function APIEmailResendRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmailResendRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'event': APIEventEnumFromJSON(json['event']),
    };
}

export function APIEmailResendRequestToJSON(value?: APIEmailResendRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'event': APIEventEnumToJSON(value['event']),
    };
}

